
/**
 * Facebook Pixel utility functions
 */

// Type definitions for the window.fbq function
declare global {
  interface Window {
    fbq: (
      command: string, 
      eventName: string, 
      parameters?: Record<string, any>
    ) => void;
    _fbq: any;
  }
}

/**
 * Track a standard page view event
 */
export const trackPageView = (): void => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
    console.info('Facebook Pixel: PageView event tracked on route change');
  }
};

/**
 * Track a purchase event with optional parameters
 * @param value - The monetary value of the purchase
 * @param currency - The currency code (default: USD)
 * @param additionalData - Any additional data to pass to the event
 */
export const trackPurchase = (
  value: number,
  currency: string = 'USD',
  additionalData: Record<string, any> = {}
): void => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      value,
      currency,
      ...additionalData
    });
    console.info(`Facebook Pixel: Purchase event tracked (${value} ${currency})`);
  }
};

/**
 * Initialize pixel and verify it's working
 */
export const verifyPixelInitialization = (): boolean => {
  if (typeof window !== 'undefined' && window.fbq) {
    console.info('Facebook Pixel successfully initialized');
    return true;
  }
  console.warn('Facebook Pixel not initialized');
  return false;
};
